import { useCallback, useReducer } from "react";
import { MIN_ITEMS_TO_SHOW } from "../utils/autocomplete.js";
import { StoreActions, StoreTypes } from "./types.js";
const INITIAL_STATE = {
    suggestionsObject: {},
    suggestions: [],
    query: '',
    value: '',
    previousValue: '',
    showSuggestions: false,
    isLoading: false
};
function reducer(state, action) {
    switch(action.type){
        case StoreTypes.OPEN_SUGGESTIONS:
            return {
                ...state,
                showSuggestions: state.query.length >= MIN_ITEMS_TO_SHOW
            };
        case StoreTypes.CLOSE_SUGGESTIONS:
            return {
                ...state,
                showSuggestions: false
            };
        case StoreTypes.SET_QUERY:
            return {
                ...state,
                query: action.payload,
                suggestions: state.suggestionsObject[action.payload] || []
            };
        case StoreTypes.SET_VALUE:
            return {
                ...state,
                value: action.payload
            };
        case StoreTypes.SET_PREVIOUS_VALUE:
            return {
                ...state,
                previousValue: action.payload
            };
        case StoreTypes.SET_SUGGESTIONS:
            return {
                ...state,
                suggestionsObject: {
                    ...state.suggestionsObject,
                    [state.query]: action.payload
                },
                suggestions: action.payload
            };
        case StoreTypes.SELECT_SUGGESTION:
            return {
                ...state,
                selectedSuggestion: action.payload
            };
        case StoreTypes.SELECTING_SUGGESTION:
            return {
                ...state,
                selectingSuggestion: action.payload
            };
        case StoreTypes.CONFIRM_SUGGESTION:
            return {
                ...state,
                selectedSuggestion: action.payload || undefined,
                selectingSuggestion: undefined,
                query: action.payload?.text || '',
                value: action.payload?.text || '',
                showSuggestions: false
            };
        case StoreTypes.CANCEL_SUGGESTION:
            return {
                ...state,
                value: state.selectedSuggestion?.text ?? '',
                selectingSuggestion: undefined,
                showSuggestions: false
            };
        default:
            return state;
    }
}
export const useStore = (init)=>{
    const defaultInit = ()=>INITIAL_STATE;
    const initFc = init ?? defaultInit;
    const [state, dispatch] = useReducer(reducer, INITIAL_STATE, initFc);
    const closeSuggestions = useCallback(()=>dispatch(StoreActions.closeSuggestions()), []);
    const openSuggestions = useCallback(()=>dispatch(StoreActions.openSuggestions()), []);
    const setQuery = useCallback((query)=>dispatch(StoreActions.setQuery(query)), []);
    const setValue = useCallback((value)=>dispatch(StoreActions.setValue(value)), []);
    const setPreviousValue = useCallback((value)=>dispatch(StoreActions.setPreviousValue(value)), []);
    const setSuggestions = useCallback((suggestions)=>dispatch(StoreActions.setSuggestions(suggestions)), []);
    const selectSuggestion = useCallback((suggestion)=>dispatch(StoreActions.selectSuggestion(suggestion)), []);
    const selectingSuggestion = useCallback((suggestion)=>dispatch(StoreActions.selectingSuggestion(suggestion)), []);
    const confirmSuggestion = useCallback((suggestion)=>dispatch(StoreActions.confirmSuggestion(suggestion)), []);
    const cancelSuggestion = useCallback(()=>dispatch(StoreActions.cancelSuggestion()), []);
    return {
        store: state,
        closeSuggestions,
        openSuggestions,
        setQuery,
        setValue,
        setPreviousValue,
        setSuggestions,
        selectSuggestion,
        selectingSuggestion,
        confirmSuggestion,
        cancelSuggestion
    };
};

//# sourceMappingURL=reducer.js.map